import { TextField } from "@mui/material"
import { IUserLogGroup } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled, FormStyled } from "fwork.react.apptemplate"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "../../apiClient/axios"
import { UsersLogsGroupsApiClient } from "../../apiClient/usersLogsGroups"
import { DEFAULTGAP } from "../../globals"
import { FloatActionButton } from "../common/floatActionButton"

export const LogsClassificationComponent = (props: {
  id?: number
}) => {
  const [data, setData] = useState<IUserLogGroup>()

  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()

  const getData = async () => {
    try {
      const response = await new UsersLogsGroupsApiClient(axios).get({
        where: {
          id: Number(props.id)
        },
        exclude: '_id',
        sort: { name: 1 }
      })

      if (response.success && response?.data?.payload) {
        setData(response.data.payload[0])
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
    }
  }

  const [saving, setSaving] = useState<boolean>(false)
  const save = async () => {
    if (saving) return
    setSaving(true)
    try {
      if (data) {
        const response =
          data.id ? await new UsersLogsGroupsApiClient(axios).put({ data }) : await new UsersLogsGroupsApiClient(axios).post({ data })
        if (response.success) {
          if (response.data?.id)
            data.id = response.data?.id
          enqueueSnackbar('Alterações salvas com sucesso.', { variant: 'success' })
        }
        else
          enqueueSnackbar(response.msg || 'Erro ao salvar alterações.', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
    finally {
      setSaving(false)
    }
  }

  useEffect(() => {
    if (props.id)
      getData()
    else setData({} as IUserLogGroup)
  }, [])

  return <>
    <FormStyled gap={DEFAULTGAP}>
      <FormItemStyled gap={DEFAULTGAP}>
        <TextField
          InputLabelProps={{ shrink: true }}
          value={data?.name || ''}
          label={"Nome"}
          onChange={(e) => setData({
            ...data,
            name: e.target.value
          } as IUserLogGroup)}
        />
      </FormItemStyled>
      <FloatActionButton progress={saving} onCancelClick={() => navigate(-1)} onConfirmClick={save} />
    </FormStyled>
  </>
}